module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-600px-dark-theme-e0cc58f6698024797e9503841af72ee1.jpg";